/**
 * Resolves a stored media path to a URL the browser can actually load.
 *
 * Uploads are saved as server-relative paths like `/uploads/vendors/x.jpg`.
 * In production that resolves fine because nginx serves the API and the app from
 * one origin (REACT_APP_API_URL is `/api`). In development the API lives on
 * :5000 while the app runs on :3000, so a bare `/uploads/...` would 404 against
 * the dev server — it needs the API origin prepended.
 *
 * Absolute URLs (remote stock photos, YouTube links) are returned untouched.
 */
const API_BASE = (process.env.REACT_APP_API_URL || 'http://localhost:5000/api').replace(/\/api\/?$/, '');

export default function mediaUrl(url) {
  if (!url) return '';
  if (/^(https?:)?\/\//i.test(url) || url.startsWith('data:')) return url;
  if (url.startsWith('/')) return API_BASE + url;
  return url;
}
